(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nuyva-bundlex-offers"] && !Shopify.designMode) return;
  try {
    // Display only: Bundlex remains solely responsible for quantities and discounts.
  class NuyvaBundlexOffers extends HTMLElement {
    connectedCallback() {
      this.anchor = this.querySelector('[data-bundlex-widget]');
      this.button = this.querySelector('button[name="add"]');
      this.label = this.button?.querySelector('span');
      this.intro = this.closest('product-info')?.querySelector('.nuyva-cro-intro');
      this.originalReference = this.intro?.querySelector('[data-cro-main-reference]')?.textContent;
      if (!this.anchor || !this.label) return;
      this.observer = new MutationObserver(() => this.syncPrice());
      this.observer.observe(this.anchor, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['aria-checked', 'class']
      });
      this.syncPrice();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    syncPrice() {
      const selected = this.anchor.querySelector('[role="radio"][aria-checked="true"]');
      const price = selected?.querySelector('.bx-discounted-price')?.textContent.trim() || this.dataset.basePrice;
      if (!price) return;
      if (!this.button.disabled) {
        const label = this.dataset.ctaTemplate.replace('__PRICE__', price);
        if (this.label.textContent !== label) this.label.textContent = label;
      }
      if (!this.intro) return;
      const mainPrice = this.intro.querySelector('[data-cro-main-price]');
      if (mainPrice && mainPrice.textContent !== price) mainPrice.textContent = price;
      const bundleReference = selected?.querySelector('.bx-original-price')?.textContent.trim();
      const reference = this.intro.querySelector('[data-cro-main-reference]');
      const referenceGroup = this.intro.querySelector('[data-cro-main-reference-group]');
      const discount = this.intro.querySelector('[data-cro-main-discount]');
      if (reference) reference.textContent = bundleReference || this.originalReference || '';
      if (referenceGroup) referenceGroup.hidden = !reference?.textContent.trim();
      if (discount) discount.hidden = Boolean(bundleReference) || !this.originalReference?.trim();
    }
  }
  if (!customElements.get('nuyva-bundlex-offers')) {
    customElements.define('nuyva-bundlex-offers', NuyvaBundlexOffers);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nuyva-cro-demo-position"] && !Shopify.designMode) return;
  try {
    class NuyvaCroDemoPosition extends HTMLElement {
    connectedCallback() {
      this.moveDemo = this.moveDemo || this.relocate.bind(this);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.moveDemo, { once: true });
      } else {
        this.relocate();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.moveDemo);
    }

    relocate() {
      if (!this.isConnected || this.childElementCount) return;
      const source = document.querySelector('[data-nuyva-cro-demo-source]');
      const section = source && source.closest('.shopify-section');
      if (section && !section.contains(this)) this.append(section);
    }
  }

  if (!customElements.get('nuyva-cro-demo-position')) {
    customElements.define('nuyva-cro-demo-position', NuyvaCroDemoPosition);
  }
  } catch(e) { console.error(e); }
})();

})();
